<template>
  <v-container style="max-width: 1500px">
    <div v-if="loading" style="text-align: center;">
      <v-progress-circular
          :size="50"
          :width="4"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
    <v-card v-else>
      <v-card-title
          class="font-light"
          style="display: inline-block; width: 100%"
      >
        <span class="float-left text-left">Manage Permission</span>
        <span
            v-if="canCreatePermission || canEditPermission"
            class="float-right text-right"
        >
          <v-btn
              color="success"
              elevation="3"
              small
              @click="updatePermission()"
          >
            Save
          </v-btn>
        </span>
      </v-card-title>
      <v-spacer></v-spacer>

      <v-divider class="mx-3" horizontal></v-divider>
      <v-row no-gutters>
        <v-col
        >
          <v-simple-table>
            <template v-slot:default>
              <thead style="background-color: #eff6ff">
              <tr>
                <th class="text-left">User Group Name</th>
              </tr>

              <tr>
                <v-text-field
                    v-model="searchGroup"
                    append-icon="mdi-magnify"
                    hide-details
                    label="Search User Group Name"
                    single-line
                    v-on:input="filteredUserGroups()"
                ></v-text-field>
              </tr>
              </thead>
              <tbody v-if="!searchResultGroupName.length">
              <tr>
                <td>No user groups found!</td>
              </tr>
              </tbody>
              <tbody v-if="searchResultGroupName.length">
              <tr
                  v-for="(item, index) in searchResultGroupName"
                  :key="index"
                  :class="{
                    selected: selectedGroup == searchResultGroupName[index],
                  }"
                  class="cursor"
                  @click="handleUserGroup(index)"
              >
                <td>{{ item.groupName }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-divider class="mx-3 bg-teal-600" vertical></v-divider>
        <v-col
        >
          <v-simple-table>
            <template v-slot:default>
              <thead style="background-color: #eff6ff">
              <tr>
                <th class="text-left">Role Name</th>
              </tr>
              <tr>
                <v-text-field
                    v-model="searchRole"
                    append-icon="mdi-magnify"
                    hide-details
                    label="Search Role Name"
                    single-line
                    v-on:input="filteredRolename()"
                ></v-text-field>
              </tr>
              </thead>
              <tbody v-if="!searchResultRoleName.length && !showRole">
              <tr>
                <td>
                  No roles defined under this user group or no user group is
                  selected!
                </td>
              </tr>
              </tbody>
              <tbody v-if="searchResultRoleName.length && showRole">
              <tr
                  v-for="(item, index) in searchResultRoleName"
                  :key="index"
                  :class="{
                    selected: selectedRole == searchResultRoleName[index],
                  }"
                  class="cursor"
                  @click="handleRole(index)"
              >
                <td>{{ item.roleName }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col
        >
        <v-divider class="mx-3 bg-teal-600" vertical></v-divider>
        <v-col
        >
          <v-simple-table>
            <template v-slot:default>
              <thead style="background-color: #eff6ff">
              <tr>
                <th class="text-left">Menu Items</th>
              </tr>
              <tr>
                <v-text-field
                    v-model="searchMenuItem"
                    append-icon="mdi-magnify"
                    hide-details
                    label="Search Menu Items"
                    single-line
                    v-on:input="filteredMenuItems()"
                ></v-text-field>
              </tr>
              </thead>
              <tbody v-if="!searchResultMenuItems.length && !showMenuItems">
              <tr>
                <td>
                  No menu items found under this role or no role is selected!
                </td>
              </tr>
              </tbody>
              <tbody v-if="searchResultMenuItems.length && showMenuItems">
              <tr
                  v-for="(item, index) in searchResultMenuItems"
                  :key="index"
                  :class="{
                    selected: selectedMenuItems == searchResultMenuItems[index],
                  }"
                  class="cursor"
                  @click="handleMenuItem(index)"
              >
                <td>{{ item.menuItem.menuItemName }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col
        >
        <v-divider class="mx-3 bg-teal-600" vertical></v-divider>
        <v-col
        >
          <v-simple-table>
            <template v-slot:default>
              <thead style="background-color: #eff6ff">
              <tr>
                <th class="text-left">Permissions</th>
              </tr>
              </thead>
              <tbody v-if="!showPermissions">
              <tr>
                <td>
                  No permissions found under this menu item or no menu item is
                  slected!
                </td>
              </tr>
              </tbody>
              <tbody v-if="showPermissions">
              <ul>
                <li style="display: inline-block; width: 100%;">
                    <span class="mt-5" style="float: left; text-align: left"
                    ><v-icon class="mr-2" style="color: teal"
                    >mdi-plus-circle</v-icon
                    >Can Create</span
                    >
                  <v-checkbox
                      v-model="permission.canCreate"
                      style="float: right; text-align: right"
                  ></v-checkbox>
                </li>
                <li style="display: inline-block; width: 100%">
                    <span class="mt-5" style="float: left; text-align: left"
                    ><v-icon class="mr-2" style="color: teal">mdi-eye</v-icon
                    >Can Read</span
                    >
                  <v-checkbox
                      v-model="permission.canRead"
                      style="float: right; text-align: right"
                  ></v-checkbox>
                </li>
                <li style="display: inline-block; width: 100%">
                    <span class="mt-5" style="float: left; text-align: left"
                    ><v-icon class="mr-2" style="color: teal"
                    >mdi-circle-edit-outline</v-icon
                    >Can Update</span
                    >
                  <v-checkbox
                      v-model="permission.canUpdate"
                      style="float: right; text-align: right"
                  ></v-checkbox>
                </li>
                <!-- <li style="display: inline-block; width: 100%">
                  <span class="mt-5" style="float: left; text-align: left"
                    ><v-icon
                      class="mr-2"
                      style="color: teal"
                      >mdi-trash-can</v-icon
                    >Can Delete</span
                  >
                  <v-checkbox
                    v-model="permission.canDelete"
                    style="float: right; text-align: right"
                  ></v-checkbox>
                </li> -->
                <li style="display: inline-block; width: 100%">
                    <span class="mt-5" style="float: left; text-align: left"
                    ><v-icon class="mr-2" style="color: teal"
                    >mdi-eye-check</v-icon
                    >Can Read Others</span
                    >
                  <v-checkbox
                      v-model="permission.canReadOthers"
                      style="float: right; text-align: right"
                  ></v-checkbox>
                </li>
                <li style="display: inline-block; width: 100%">
                    <span class="mt-5" style="float: left; text-align: left"
                    ><v-icon class="mr-2" style="color: teal"
                    >mdi-book-check</v-icon
                    >Can Accredit Courses</span
                    >
                  <v-checkbox
                      v-model="permission.canAccreditCourse"
                      style="float: right; text-align: right"
                  ></v-checkbox>
                </li>
              </ul>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import {PermissionService} from "./permission.service";
import {UserGroupService} from "../UserGroup/Usergroup.service";
import {getUser} from "@/utils/helper";

export default {
  data() {
    return {
      roles: [],
      permission: [],
      roleIndex: 0,
      permissionIndex: 0,
      user_groups: [],
      MENU_ITEMS: [],
      showPermissions: false,
      showRole: false,
      showMenuItems: false,
      menuIndex: 0,
      formValues: [],
      selectedGroup: null,
      selectedRole: null,
      selectedMenuItems: null,
      loading: false,
      searchGroup: null,
      searchRole: null,
      searchMenuItem: null,
      searchResultGroupName: [],
      searchResultRoleName: [],
      searchResultMenuItems: [],
    };
  },
  async beforeMount() {
    this.fetchUserGroups();
  },
  computed: {
    canCreatePermission() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Permissions" &&
              permission.canCreate
      );
    },
    canEditPermission() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Permissions" &&
              permission.canUpdate
      );
    },
  },
  methods: {
    filteredUserGroups() {
      this.searchResultGroupName = this.user_groups.filter((usergroup) => {
        return usergroup.groupName
            .toLowerCase()
            .match(this.searchGroup.toLowerCase());
      });
    },
    filteredRolename() {
      this.searchResultRoleName = this.roles.filter((role) => {
        return role.roleName.toLowerCase().match(this.searchRole.toLowerCase());
      });
    },
    filteredMenuItems() {
      this.searchResultMenuItems = this.MENU_ITEMS.filter((menuitems) => {
        return menuitems.menuItem.menuItemName
            .toLowerCase()
            .match(this.searchMenuItem.toLowerCase());
      });
    },
    handleUserGroup(item) {
      this.showPermissions = false;
      this.showMenuItems = false;
      this.showRole = false;
      this.MENU_ITEMS = [];
      this.roleIndex = item;
      this.selectedGroup = this.searchResultGroupName[this.roleIndex];
      this.roles = this.selectedGroup.roles;
      this.searchResultRoleName = this.roles;
      this.showRole = true;
      this.searchRole = null;
      this.searchMenuItem = null;
    },
    handleRole(item) {
      this.showPermissions = false;
      this.menuIndex = item;
      this.showMenuItems = true;
      this.selectedRole = this.searchResultRoleName[item];
      this.MENU_ITEMS = this.selectedRole.role_menu_permissions;
      this.searchResultMenuItems = this.MENU_ITEMS;
      this.searchMenuItem = null;
    },
    resetPermissions() {
      this.menuIndex = 0;
      this.MENU_ITEMS = [];
      this.permission = null;
      this.showPermissions = false;
      this.roleIndex = 0;
      this.roles = [];
      this.user_groups = [];
      this.showRole = false;
      this.showMenuItems = false;
      this.fetchUserGroups();
    },
    handleMenuItem(item) {
      this.permission = this.searchResultMenuItems[item];
      this.selectedMenuItems = this.searchResultMenuItems[item];
      this.formValues.push(this.permission);
      this.showPermissions = true;
    },
    async updatePermission() {
      this.loading = true;
      let res = await PermissionService.update(this.formValues);
      if (res.status === 201) {
        switch (res.data.status) {
          case 200:
            this.$toast.success(res.data.message);
            this.resetPermissions();
            this.loading = false;
            break;
          case 500:
            this.$toast.error(res.data.message);
            this.loading = false;
            break;
        }
      } else {
        this.$toast.error("Unable to update permission, please try again");
      }
    },
    async fetchUserGroups() {
      this.loading = true;
      const res = await UserGroupService.getUserGroups();
      if (res.status === 200) {
        this.loading = false;
        this.user_groups = res.data.rows;
        this.searchResultGroupName = this.user_groups;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching user groups, Please try Again!"
        );
      }
    },
  },
};
</script>
<style scoped>
.custom-label input:checked + svg {
  display: block !important;
}

tr.selected {
  background-color: #1ab394;
}

.cursor {
  cursor: pointer;
}

.check {
  vertical-align: middle;
  text-align: center;
  display: inline-block;
  width: 100%;
}

.selected {
  background-color: honeydew !important;
  color: black;
}
</style>
